import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import MySteps from "./MySteps";
import http from "../../services/HttpService";
import config from "../../config.json";
import auth from "../../services/authService";
import BprmForm from "../../comman/BprmForm";
import SubForm from "../PartnerManage/SubForm";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";

class ReviewSubProcessPopup extends BprmForm {

  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      aWorkfinityAppEntity: "",
      aWorkfinityApp: "",
      application: "",
      workItem: "",
      allApplication: [],
      application: "",
      workflowShowHide: false,
      selectedObj: "",
      currentTask: "",
      historyAppShowHide: false,
      toolObj: "",
      toolShowHide: false,
      documents: [],
      showHide: false,
      formProcess: [],
      processId: 0,
      viewOnlyMode: false,
      reAssignShowHide: false,
      bcChecks: [],
      bcCheckShowHide: false,
      backgroundCheckApp: [],
      bcType: "",
      bcObject: "",
    };
  }

  schema = {};

  async componentWillReceiveProps(prevProps) {
    const { selectedTask } = prevProps;
    //console.log(selectedTask);
    if (selectedTask !== "") {
      this.loadSubprocessApp(selectedTask);
      this.loadBackgroundChecks(selectedTask);
    }
  }

  handleReAssignModalShowHide = (obj) => {
    this.setState({
      reAssignShowHide: !this.state.reAssignShowHide,
      selectedObj: obj,
    });
  };

  handleReAssignSubmit = async () => {
    this.setState({ reAssignShowHide: false });
    const { selectedTask } = this.props;
    //console.log(selectedTask);
    if (selectedTask !== "") {
      this.loadSubprocessApp(selectedTask);
    }
  };

  loadSubprocessApp = async (selectedTask) => {
    const currentUser = auth.getCurrentUser();
    const { data: app } = await http.post(
      config.GetSubprocessApp,
      selectedTask
    );
    //console.log(app);
    if (app > 0) {
      const { data: applications } = await http.get(
        config.GetApplicantApps +
        selectedTask.applicantId +
        "&type=" +
        currentUser.type +
        "&userId=" +
        currentUser.id +
        "&appId=" +
        app
      );
      //console.log(applications);
      if (applications.length > 0) {
        this.setState({
          allApplication: applications,
          application: applications[0],
        });

        const wfTasks = applications[0].workflowTasks.filter(
          (x) => x.itemType === 1 && x.wiid > 0
        );
        //console.log(wfTasks);
        if (wfTasks.length > 0) {
          const wfTask = wfTasks[wfTasks.length - 1];
          this.loadBprmFormData(wfTask);
          this.setState({ currentTask: wfTask });
        } else {
          this.setState({ currentTask: "", wfForm: "" });
          setTimeout(() => {
            this.loadSubprocessApp(selectedTask);
          }, 3000);
        }
      }
    }
  };

  loadBackgroundChecks = async (selectedTask) => {
    //console.log(selectedTask);
    const { data: bcChecks } = await http.get(
      config.GetBackgroundChecks + selectedTask.applicantId
    );
    this.setState({ bcChecks });
  };

  loadBprmFormData = async (workItem) => {
    if (workItem.formId > 0) {
      const { data: wfForm } = await http.get(config.GetForm + workItem.formId);
      //this.loadCMDropdownSubform(wfForm);
      this.setState({ wfForm });
      const { data: application } = await http.delete(
        config.GetApplication + workItem.ciid
      );
      //console.log(application);
      this.schema = {};
      const aWorkfinityApp = JSON.parse(application.applicationData);
      const appShortName = Object.keys(aWorkfinityApp)[1];
      const aWorkfinityAppEntity = aWorkfinityApp[appShortName];
      const data = {}; //{ data } = this.state;
      //console.log(aWorkfinityAppEntity);
      Object.keys(aWorkfinityAppEntity).forEach(function (keyValue) {
        if (
          keyValue !== "@xmlns:xsd" &&
          keyValue !== "@xmlns:xsi" &&
          keyValue !== "EntityId"
        ) {
          Object.keys(aWorkfinityAppEntity[keyValue]).forEach(function (
            keyValue1
          ) {
            if (keyValue1 !== "EntityId") {
              const item = aWorkfinityAppEntity[keyValue][keyValue1];
              //console.log(item);
              if (typeof item === "object") {
                if (Array.isArray(item))
                  data[keyValue + "." + keyValue1.replace("@", "")] = item;
                else data[keyValue + "." + keyValue1.replace("@", "")] = [item];
              } else {
                data[keyValue + "." + keyValue1.replace("@", "")] = item;
              }
            }
          });
        }
      });

      //const user = auth.getCurrentUser();
      // const currentUser = await auth.getCurrentUserDetails(user.id);
      //console.log(data);

      this.setState({
        aWorkfinityAppEntity,
        aWorkfinityApp,
        //application,
        workItem,
        data,
      });
    }
  };

  handleWorkflowModalShowHide = (obj) => {
    this.setState({
      workflowShowHide: !this.state.workflowShowHide,
      selectedObj: obj,
    });
  };

  getFieldData = (aWorkfinityApp, attribue, filedName) => {
    const appEntity = JSON.parse(aWorkfinityApp);
    const appShortName = Object.keys(appEntity)[1];
    const aWorkfinityAppEntity = appEntity[appShortName];
    const obj = aWorkfinityAppEntity[attribue];
    if (obj["@" + filedName]) return "";
    return obj["@" + filedName];
  };

  getWfPhasesColor(phase) {
    switch (phase) {
      case "Closed":
        return "btn-default";
      case "Review":
        return "btn-secondary bg-yellow border-0";
      case "Application":
        return "btn-outline-default";
      case "Pending":
        return "btn-info";
      case "Approved":
        return "btn-success";
      case "Denied":
        return "btn-danger";
      case "Withdrawn":
        return "btn-warning";
    }
  }

  handleJorneySteps = (wiid) => {
    const { application: app } = this.state;
    this.setState({ selectedTask: parseInt(wiid) });
    const wfTask = app.workflowTasks.filter(
      (x) => x.wiid === parseInt(wiid)
    )[0];
    this.loadBprmFormData(wfTask);
    this.setState({ currentTask: wfTask });
  };

  handlehistoryAppModalShowHide = (obj) => {
    this.setState({ historyAppShowHide: !this.state.historyAppShowHide });
    //this.setSelectedObj(this.state.historyAppShowHide, obj);
    this.setState({ selectedObj: obj });
  };

  handleToolShowHide = (r) => {
    this.setState({
      toolShowHide: !this.state.toolShowHide,
      toolObj: r,
    });
  };

  async doSubmit(btn) {
    const btnType = btn.name;
    const processId = btn.dataset.process;
    const { aWorkfinityAppEntity, data, aWorkfinityApp, workItem, documents } =
      this.state;
    Object.keys(data).forEach(function (keyValue) {
      const dd = keyValue.split(".");
      if (dd.length > 1) {
        if (dd[1] !== "undefined" && aWorkfinityAppEntity !== undefined)
          if (aWorkfinityAppEntity[dd[0].toLowerCase()] !== undefined) {
            var item = data[keyValue];
            if (Array.isArray(item))
              aWorkfinityAppEntity[dd[0].toLowerCase()][dd[1]] = item;
            else aWorkfinityAppEntity[dd[0].toLowerCase()]["@" + dd[1]] = item;
          }
      }
    });
    const appShortName = Object.keys(aWorkfinityApp)[1];
    aWorkfinityApp[appShortName] = aWorkfinityAppEntity;
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(aWorkfinityApp));
    formData.append("workItem", JSON.stringify(workItem));
    formData.append("upDocs", JSON.stringify(documents));
    documents.map((file, key) =>
      formData.append("files[" + key + "]", file.file)
    );
    this.setState({ showHide: true, processId });
    const { data: appEntity } = await http.post(config.SaveFormData, formData);
    if (btnType !== "save") {
      const { data: nextWorkItem } = await http.post(
        config.SetWorkItemToDone,
        workItem
      );
      this.handleNextTask();
    }
  }

  handleNextTask = () => {
    //window.location.href = "/ManageApplication";
    //this.props.history.goBack();
    setTimeout(() => {
      this.setState({
        showHide: false,
        documents: [],
        data: {},
        errors: {},
        aWorkfinityApp: "",
        aWorkfinityAppEntity: "",
      });
      const { selectedTask } = this.props;
      //console.log(selectedTask);
      this.loadBackgroundChecks(selectedTask);
      this.loadSubprocessApp(selectedTask);
    }, 3000);
  };

  handleDeleteTimeSheetDoc = async (id) => {
    const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
    if (result.isConfirmed) {
      const response = await http.get(
        config.DeleteTimeLogTimeSheetDoc + id
      );
      if (response) {
        getAlert("", "Deleted Successfully", "success");
      }
    }
  }

  handleModalShowHide = () => {
    this.setState({ showHide: !this.state.showHide });
  };

  handleBcCheckShowHide = async (obj, type) => {
    if (obj === "save") {
      const { candidateObj: objItem } = this.props;
      const { data: bcChecks } = await http.get(
        config.GetBackgroundChecks + objItem.performerid
      );
      this.setState({
        bcChecks,
        bcObject: "",
        bcType: "",
        bcCheckShowHide: false,
      });
    } else {
      this.setState({
        bcCheckShowHide: !this.state.bcCheckShowHide,
        bcObject: obj,
        bcType: type,
      });
    }
  };

  handleDownloadFile = async (item) => {
    try {
      const { data } = await http.get(config.DownloadDocument + item.id, {
        responseType: "blob",
      });
      if (data.size > 0) {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", item.documentName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.log(error);
    }

    // const { data } = await http.get(config.DownloadDocument + item.docId);
    // if (data !== "Fail") {
    //   this.download(item.docName.trim(), data);
    // }
  };

  handleDeleteBcChecks = (id) => {
    Swal.fire({
      title: "",
      text: "Are you sure you want to delete this background check?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Yes",
      cancelButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { data } = await http.get(config.DeleteBackgroundChecks + id);
        getAlert("", "Deleted Successfully", "success");
        const { selectedTask } = this.props;
        this.loadBackgroundChecks(selectedTask);
      }
    });
  };

  // getAlert(title, message, type) {
  //   return Swal.fire({
  //     title: title,
  //     text: message,
  //     icon: type,
  //     confirmButtonText: "Close",
  //     confirmButtonColor: "#d33",
  //   });
  // }

  render() {
    const {
      processShowHide,
      handleProcessShowHide,
      compList,
      //handleToolShowHide,
      custApp: app,
      selectedTask,
      candidateObj,
    } = this.props;
    console.log(this.props);
    const {
      aWorkfinityApp,
      aWorkfinityAppEntity,
      subformDataType,
      data,
      wfForm,
      subformItemIndex,
      currentTask,
      application,
      selectedObj,
      workflowShowHide,
      historyAppShowHide,
      toolObj,
      toolShowHide,
      showHide,
      processId,
      viewOnlyMode,
      reAssignShowHide,
      bcChecks,
      bcCheckShowHide,
      backgroundCheckApp,
      bcObject,
      bcType,
    } = this.state;
    let wfTask = currentTask;
    let elements = //htmlJsonString;
      wfForm?.elementJson != undefined && JSON.parse(wfForm?.elementJson);
    //elements = [];
    let newComList = compList.filter((x) => x.id === 2 || x.id === 5);

    return (
      <React.Fragment>
        <Modal show={processShowHide} size="xl">
          <Modal.Header closeButton onHide={() => handleProcessShowHide("")}>
            <Modal.Title>
              <img
                src="/assets/Images/WFAssociationIcons/subprocess.gif"
                title="Subprocess"
                onClick={() => this.handleWorkflowModalShowHide(application)}
                style={{
                  height: "18px",
                  marginRight: "5px",
                  marginTop: "-3px",
                }}
              />
              {selectedTask?.itemName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row" style={{ maxHeight: 600, overflow: "auto" }}>
              <div className="col-md-12 form-group">
                <div className="table-responsive">
                  <table className="table align-items-center table-hover table-striped border bg-white">
                    <thead className="thead-light">
                      <tr>
                        <th>App Id</th>
                        <th>Task</th>
                        <th>Start (Date & Time)</th>
                        <th>End (Date & Time)</th>
                        <th>Assigned To</th>
                        <th>Re-Assign Task</th>
                        <th>Status</th>
                        <th>History</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{wfTask.ciid}</td>
                        <td style={{ whiteSpace: "pre-wrap" }}>
                          {wfTask.itemName}
                        </td>
                        <td>
                          <Moment format="MMM Do YYYY, h:mm a">
                            {wfTask.startDate}
                          </Moment>
                        </td>
                        <td>
                          {wfTask.endDate !== null && (
                            <Moment format="MMM Do YYYY, h:mm a">
                              {wfTask.endDate}
                            </Moment>
                          )}
                        </td>

                        <td>
                          {wfTask.performerName}
                          <br />
                          {wfTask.performerRole}
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-link"
                            data-toggle="tooltip"
                            data-original-title="Task Re-Assign"
                            onClick={() =>
                              this.handleReAssignModalShowHide(wfTask)
                            }
                          >
                            Re-Assign
                          </button>
                        </td>
                        <td>
                          {wfTask.status ? (
                            <button className="btn btn-sm btn-outline-default">
                              Done
                            </button>
                          ) : (
                            <button
                              className={`btn btn-sm ${this.getWfPhasesColor(
                                wfTask.wfPhase
                              )}`}
                            >
                              {wfTask.wfPhase}
                            </button>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-outline-default btn-sm"
                            onClick={() =>
                              this.handlehistoryAppModalShowHide(wfTask)
                            }
                            title="View Task History"
                          >
                            <i class="fa fa-bars" aria-hidden="true"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="col-md-12">
                <div className="card shadow-none border">
                  {/* <div className="card-header p-2 bg-admin-sub-light border-admin-sub-left">
                    <div className="row">
                      <div className="col-md-6">
                        <h4 className="mb-0 text-uppercase">
                          Background Check
                        </h4>
                      </div>
                      <div className="col-md-6 text-right">
                        <button
                          className="btn btn-outline-default btn-sm"
                          onClick={() => this.handleBcCheckShowHide("", "")}
                          //onClick={this.handleRunApplication}
                        >
                          Add Background Check
                        </button>
                      </div>
                    </div>
                  </div> */}
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-md-6">
                        {/* <h5>Background Check Results</h5> */}
                      </div>
                      <div className="col-md-6 text-right">
                        <a
                          href="https://ows01.hireright.com/login/"
                          target="_blank"
                        >
                          Link To Hire Right
                        </a>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th>S.No.</th>
                            <th>Date & Time</th>
                            <th>
                              Background
                              <br />
                              Check Name
                            </th>
                            <th>
                              Internal
                              <br />
                              Notes
                            </th>
                            <th>Internal Documents</th>
                            <th>Status</th>
                            <th>
                              Notify
                              <br /> Candidate
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bcChecks.map((item, key) => (
                            <tr>
                              <td>{key + 1}</td>
                              <td>
                                <Moment format="MMM Do YYYY, h:mm a">
                                  {item.addedDateTime}
                                </Moment>
                              </td>
                              <td>{item.name}</td>
                              {/* <td className="p-2">
                              {item.docList.map((doc) => (
                                <li className="list-group-item p-1">
                                  <a href="#">{doc.documentName}</a>
                                </li>
                              ))}
                            </td> */}

                              <td>
                                <button
                                  className="btn btn-link btn-sm p-0 text-underline"
                                  onClick={() =>
                                    this.handleBcCheckShowHide(item, "edit")
                                  }
                                >
                                  View/Edit
                                </button>
                              </td>
                              <td className="p-2">
                                {item.updatedDocList.map((doc) => (
                                  <React.Fragment>
                                    <li className="list-group-item p-1">
                                      <button
                                        className="btn btn-link btn-sm p-0 text-underline"
                                        onClick={() =>
                                          this.handleDownloadFile(doc)
                                        }
                                      >
                                        {doc.documentName}
                                      </button>
                                      <button
                                        className="float-right mr-2 btn btn-sm"
                                        onClick={() =>
                                          this.handleDeleteTimeSheetDoc(item.id)
                                        }
                                      >
                                        <i
                                          className="fa fa-trash text-red"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                    </li>
                                  </React.Fragment>
                                ))}
                              </td>
                              <td>
                                {item.status === null && (
                                  <button className="btn btn-link btn-sm p-0">
                                    Pending
                                  </button>
                                )}
                                {item.status && (
                                  <button className="btn btn-link btn-sm p-0">
                                    Passed
                                  </button>
                                )}

                                {!item.status && item.status !== null && (
                                  <button className="btn btn-link btn-sm p-0">
                                    Failed
                                  </button>
                                )}
                                <br />
                                {item.updatedDateTime !== null && (
                                  <Moment format="MMM Do YYYY, h:mm a">
                                    {item.updatedDateTime}
                                  </Moment>
                                )}
                              </td>
                              <td>
                                {!item.sendStatus && (
                                  <button
                                    className="btn btn-link btn-sm p-0 text-underline"
                                    onClick={() =>
                                      this.handleBcCheckShowHide(item, "notify")
                                    }
                                  >
                                    Notify
                                  </button>
                                )}
                                {item.sendStatus && (
                                  <button className="btn btn-link btn-sm p-0">
                                    Notified
                                  </button>
                                )}
                                <br />
                                {item.notifyDateTime !== null && (
                                  <Moment format="MMM Do YYYY, h:mm a">
                                    {item.notifyDateTime}
                                  </Moment>
                                )}
                                <br />
                                {item.docList.map((doc) => (
                                  <li className="list-group-item p-1">
                                    <button
                                      className="btn btn-link btn-sm p-0 text-underline"
                                      onClick={() =>
                                        this.handleDownloadFile(doc)
                                      }
                                    >
                                      {doc.documentName}
                                    </button>
                                  </li>
                                ))}
                              </td>
                              <td>
                                <button
                                  className="btn btn-link btn-sm p-0 text-underline"
                                  onClick={() =>
                                    this.handleDeleteBcChecks(item.id)
                                  }
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <table className="table table-bordered align-items-center">
                  <thead className="thead-light">
                    <tr>
                      <th>Workflow Phases/Journey Steps</th>
                      <th>Review</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className="bg-white"
                        style={{ width: "25%", whiteSpace: "pre-wrap" }}
                      >
                        {application !== "" && (
                          <MySteps
                            custApp={application}
                            handleJorneySteps={this.handleJorneySteps}
                            compList={newComList}
                            handleToolShowHide={this.handleToolShowHide}
                          ></MySteps>
                        )}
                      </td>
                      <td>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-2">
                              <h4 className="mb-0 text-dark btn bg-yellow btn-sm">
                                <i
                                  className="fa fa-arrow-right mr-2"
                                  aria-hidden="true"
                                ></i>
                                {wfTask.itemName}
                              </h4>
                            </div>
                            <div className="card shadow-none border">
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-12">
                                    {wfTask.performerRole ===
                                      "Field Inspectors" && (
                                        <>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-default"
                                            onClick={() =>
                                              this.handleToolShowHide(
                                                compList.filter(
                                                  (x) => x.id === 11
                                                )[0]
                                              )
                                            }
                                          >
                                            Schedule Appointment
                                          </button>
                                          <br />
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-default mt-2"
                                            onClick={() =>
                                              this.handleToolShowHide(
                                                compList.filter(
                                                  (x) => x.id === 21
                                                )[0]
                                              )
                                            }
                                          >
                                            Google Maps
                                          </button>
                                        </>
                                      )}
                                  </div>
                                  <div className="col-md-12 mb-3">
                                    {wfTask?.performerRole ===
                                      "TDA Accountant" && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-default"
                                          onClick={() =>
                                            this.handleToolShowHide(
                                              compList.filter(
                                                (x) => x.id === 21
                                              )[0]
                                            )
                                          }
                                        >
                                          Payment Information
                                        </button>
                                      )}
                                  </div>
                                </div>
                                <div className="row">
                                  {elements &&
                                    elements
                                      .filter(
                                        (x) => x.groupName !== "otherCriteria"
                                      )
                                      .map((col) => (
                                        <div className={`col-` + col.width}>
                                          {col.components.map((comp) => {
                                            if (comp.dataType === "list") {
                                              //console.log(comp);
                                              const controleId =
                                                comp.attributeType.toLowerCase() +
                                                "." +
                                                comp.attributeObject;
                                              return (
                                                <React.Fragment>
                                                  <SubForm
                                                    showHide={
                                                      this.state[
                                                      "showHide" +
                                                      comp.subform
                                                      ]
                                                    }
                                                    handleModalShowHide={
                                                      this
                                                        .handleSubformModalShowHide
                                                    }
                                                    title={comp.label}
                                                    subFormId={comp.subform}
                                                    aWorkfinityAppEntity={
                                                      aWorkfinityAppEntity
                                                    }
                                                    subFormDataType={
                                                      comp.attributeType
                                                    }
                                                    subFormAttribute={
                                                      comp.attributeObject
                                                    }
                                                    handleSubformSave={
                                                      this.handleSubformSave
                                                    }
                                                    subformItemIndex={
                                                      subformItemIndex
                                                    }
                                                    formDD={
                                                      subformDataType.length >
                                                      0 &&
                                                      subformDataType.filter(
                                                        (x) =>
                                                          x.dataType ===
                                                          comp.attributeType &&
                                                          x.attribute ===
                                                          comp.attributeObject
                                                      )[0]
                                                    }
                                                  ></SubForm>
                                                  <div className="row">
                                                    <div className="col-3">
                                                      <div
                                                        className={`form-group ${comp.isRequired
                                                            ? "required"
                                                            : ""
                                                          }`}
                                                      >
                                                        <label
                                                          className="form-control-label"
                                                          htmlFor={controleId}
                                                        >
                                                          Import From Excel
                                                        </label>
                                                        <div className="custom-file">
                                                          <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id={controleId}
                                                            name={controleId}
                                                            aria-label={
                                                              comp.label
                                                            }
                                                            onChange={
                                                              this
                                                                .handleExportExcel
                                                            }
                                                          />
                                                          <label
                                                            className="custom-file-label"
                                                            htmlFor={controleId}
                                                          >
                                                            {data[
                                                              controleId
                                                            ] === undefined
                                                              ? "Select file"
                                                              : data[
                                                              controleId
                                                              ]}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="col-3 d-flex align-items-center mt-1">
                                                      <ReactHtmlTableToExcel
                                                        id="test-table-xls-button"
                                                        className="btn btn-outline-default"
                                                        table={`table-to-xls-${comp.subform}-d`}
                                                        filename={comp.label}
                                                        sheet={comp.label}
                                                        buttonText="Download Excel"
                                                      />
                                                      <table
                                                        id={`table-to-xls-${comp.subform}-d`}
                                                        className="d-none"
                                                      >
                                                        <thead>
                                                          <tr>
                                                            {subformDataType.length >
                                                              0 &&
                                                              subformDataType
                                                                .filter(
                                                                  (x) =>
                                                                    x.dataType ===
                                                                    comp.attributeType &&
                                                                    x.attribute ===
                                                                    comp.attributeObject
                                                                )[0]
                                                                .itemList.map(
                                                                  (item) => (
                                                                    <th>
                                                                      {
                                                                        item.split(
                                                                          "."
                                                                        )[1]
                                                                      }
                                                                    </th>
                                                                  )
                                                                )}
                                                          </tr>
                                                        </thead>
                                                      </table>
                                                    </div>
                                                    <div className="col-6 d-flex align-items-center mt-1 justify-content-end">
                                                      <ReactHtmlTableToExcel
                                                        id="test-table-xls-button"
                                                        className="btn btn-outline-default"
                                                        table={`table-to-xls-${comp.subform}`}
                                                        filename={comp.label}
                                                        sheet={comp.label}
                                                        buttonText="Export Excel"
                                                      />
                                                      <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() =>
                                                          this.exportPDF(comp)
                                                        }
                                                      >
                                                        Export PDF
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <table
                                                    className="table table-bordered"
                                                    id={`table-to-xls-${comp.subform}`}
                                                  >
                                                    <thead className="thead-light">
                                                      <tr>
                                                        {subformDataType.length >
                                                          0 &&
                                                          subformDataType
                                                            .filter(
                                                              (x) =>
                                                                x.dataType ===
                                                                comp.attributeType &&
                                                                x.attribute ===
                                                                comp.attributeObject
                                                            )[0]
                                                            .itemList.map(
                                                              (item) => (
                                                                <th>
                                                                  {
                                                                    item.split(
                                                                      "."
                                                                    )[1]
                                                                  }
                                                                </th>
                                                              )
                                                            )}
                                                        {comp.isEdit &&
                                                          subformDataType.length >
                                                          0 && (
                                                            <th>Action</th>
                                                          )}
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {aWorkfinityAppEntity[
                                                        comp.attributeType.toLowerCase()
                                                      ][
                                                        comp.attributeObject
                                                      ] !== undefined &&
                                                        aWorkfinityAppEntity[
                                                          comp.attributeType.toLowerCase()
                                                        ][comp.attributeObject]
                                                          .length !==
                                                        undefined &&
                                                        aWorkfinityAppEntity[
                                                          comp.attributeType.toLowerCase()
                                                        ][
                                                          comp.attributeObject
                                                        ].map((obj, key) => (
                                                          <tr>
                                                            {subformDataType.length >
                                                              0 &&
                                                              subformDataType
                                                                .filter(
                                                                  (x) =>
                                                                    x.dataType ===
                                                                    comp.attributeType &&
                                                                    x.attribute ===
                                                                    comp.attributeObject
                                                                )[0]
                                                                .itemList.map(
                                                                  (item) => (
                                                                    <td>
                                                                      {
                                                                        obj[
                                                                        "@" +
                                                                        item.split(
                                                                          "."
                                                                        )[0]
                                                                        ]
                                                                      }
                                                                    </td>
                                                                  )
                                                                )}

                                                            {comp.isEdit && (
                                                              <td>
                                                                <button
                                                                  className="btn btn-sm btn-outline-default"
                                                                  onClick={() =>
                                                                    this.handleSubformModalShowHide(
                                                                      "showHide" +
                                                                      comp.subform +
                                                                      "-" +
                                                                      key
                                                                    )
                                                                  }
                                                                >
                                                                  Edit
                                                                </button>
                                                              </td>
                                                            )}
                                                          </tr>
                                                        ))}
                                                    </tbody>
                                                  </table>
                                                </React.Fragment>
                                              );
                                            } else if (
                                              comp.dataType === "button" &&
                                              comp.buttonType !== undefined
                                            ) {
                                              if (
                                                comp.buttonType.type !==
                                                undefined &&
                                                (comp.buttonType.type ===
                                                  "editForm" ||
                                                  comp.buttonType.type ===
                                                  "subform")
                                              ) {
                                                return this.rendorHtmlComponent(
                                                  comp
                                                );
                                              }
                                            } else {
                                              return this.rendorHtmlComponent(
                                                comp
                                              );
                                            }
                                          })}
                                        </div>
                                      ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="card shadow-none border">
                              <div className="card-header text-center bg-lighter p-2">
                                <h4 className="mb-0 text-dark">
                                  <i
                                    className="fa fa-arrow-right mr-2"
                                    aria-hidden="true"
                                  ></i>
                                  WORKFLOW ACTION
                                </h4>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-md-12 text-center">
                                    <fieldset disabled={viewOnlyMode}>
                                      {elements &&
                                        elements.map((col) =>
                                          col.components.map((comp) => {
                                            if (comp.dataType === "button") {
                                              return this.rendorHtmlComponent(
                                                comp
                                              );
                                            }
                                          })
                                        )}
                                    </fieldset>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 form-group">
                            <div className="card shadow-none border">
                              <div className="card-header bg-lighter p-2">
                                <h4 className="mb-0 text-dark">
                                  Communication with applicant
                                </h4>
                              </div>
                              <div className="card-body">
                                <button
                                  className="btn btn-sm btn-outline-default"
                                  onClick={() =>
                                    this.handleToolShowHide({
                                      id: 9,
                                      group: "Messaging",
                                      name: "System Message",
                                    })
                                  }
                                >
                                  <i
                                    class="fa fa-check-square-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  System Message
                                </button>
                                <button
                                  className="btn btn-sm btn-outline-default"
                                  onClick={() =>
                                    this.handleToolShowHide({
                                      id: 38,
                                      group: "Messaging",
                                      name: "Email Message",
                                    })
                                  }
                                >
                                  <i
                                    class="fa fa-check-square-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  Email Message
                                </button>
                                <button
                                  className="btn btn-sm btn-default"
                                  onClick={() =>
                                    this.handleToolShowHide({
                                      id: 39,
                                      group: "",
                                      name: "Upload Documents",
                                    })
                                  }
                                >
                                  Upload
                                </button>
                                <button
                                  className="btn btn-sm btn-default"
                                  onClick={() =>
                                    this.handleToolShowHide({
                                      id: 24,
                                      group: "",
                                      name: "Templates Library",
                                    })
                                  }
                                >
                                  Upload Template
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant="danger" onClick={() => handleProcessShowHide("")}>
              Close
            </Button>
          </Modal.Footer> */}
        </Modal>

        {/* <WorkflowMapPopup
          workflowShowHide={workflowShowHide}
          handleWorkflowModalShowHide={this.handleWorkflowModalShowHide}
          selectedObj={selectedObj}
        ></WorkflowMapPopup> */}

        {/* <TaskHistory
          historyAppShowHide={historyAppShowHide}
          handlehistoryAppModalShowHide={this.handlehistoryAppModalShowHide}
          selectedObj={currentTask}
          doneTasks={application.workflowTasks}
        ></TaskHistory> */}

        {/* <TaskReAssignPopup
          reAssignShowHide={reAssignShowHide}
          handleReAssignModalShowHide={this.handleReAssignModalShowHide}
          selectedObj={selectedObj}
          handleReAssignSubmit={this.handleReAssignSubmit}
        ></TaskReAssignPopup> */}

        {/* <ToolsPopup
          toolShowHide={toolShowHide}
          handleToolShowHide={this.handleToolShowHide}
          toolObj={toolObj}
          item={selectedTask}
          task={wfTask}
          app={application}
        ></ToolsPopup> */}
        {/* <Progress
          showHide={showHide}
          handleModalShowHide={this.handleModalShowHide}
          processId={processId}
          formProcess={this.state.formProcess}
        ></Progress> */}
        {/* <AddBcChecks
          bcCheckShowHide={bcCheckShowHide}
          handleBcCheckShowHide={this.handleBcCheckShowHide}
          candidateObj={candidateObj}
          workItem={wfTask}
          bcObject={bcObject}
          bcType={bcType}
          //selectedObj={selectedObj}
          workflowTask={wfTask}
          backgroundCheckApp={backgroundCheckApp}
        ></AddBcChecks> */}
      </React.Fragment>
    );
  }
}

export default ReviewSubProcessPopup;
